import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import Logo from "@/components/public/Logo";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#06122E] grid-texture flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo size="lg" /></div>
        <div className="cb-card-dark p-8">
          <div className="flex items-center gap-2 mb-1"><Lock size={18} className="gold-text" /><h1 className="font-serif text-2xl text-white">Admin Panel</h1></div>
          <p className="text-slate-400 text-sm mb-6">Sign in to manage your website content.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="text-sm text-slate-300 mb-1.5 block">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#06122E] border border-[#203E70] rounded px-3 py-2.5 text-sm text-white focus:border-[#D8AE4E]/50 outline-none" data-testid="login-email" />
            </div>
            <div>
              <label className="text-sm text-slate-300 mb-1.5 block">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#06122E] border border-[#203E70] rounded px-3 py-2.5 text-sm text-white focus:border-[#D8AE4E]/50 outline-none" data-testid="login-password" />
            </div>
            <button type="submit" disabled={busy} className="btn-gold w-full py-3 disabled:opacity-60" data-testid="login-submit">
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
